/** Plain-language names for the real module strings WorkflowEngine actually uses - shared by every admin screen that lets someone pick "what is this approval for," so the wording never drifts between screens. */
export const MODULE_LABELS: Record<string, string> = {
  workforce_request: 'Hiring requests (Workforce Request)',
  contracts: 'Staff contracts',
  project: 'Project budgets',
  project_amendment: 'Project budget changes',
  recruitment: 'Job vacancies',
  programme: 'Programmes',
  leave: 'Leave requests',
  employee_training: 'Training requests',
  staff_movement: 'Staff transfers/promotions',
  probation: 'Probation decisions',
  hr_request: 'HR requests',
  journal_entry: 'Accounting journal entries',
  expense_claim: 'Expense claims',
  budget: 'Budgets',
  income_record: 'Income records',
  grant: 'Grants',
  accounts_payable: 'Payments to vendors/staff',
  accounts_receivable: 'Money owed to Verdantrise',
  general: 'General (any module not listed)',
};
